module.exports = __webpack_public_path__ + "img/klarna_paynow.ff2cf259.png";